module.exports = __webpack_public_path__ + "img/section1-1-mobile.471bd370.png";